import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

import loader from "~/assets/images/loader.gif";
import { useAuth } from "~/context/FirebaseAuthContext";

const LoadingContainer = styled.div`
  align-items: center;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 9999;
`;

const LoadingText = styled.p`
  color: #333;
  font-size: 18px;
  margin-top: 20px;
`;

function AuthLoadingWrapper({ children }) {
  const { t } = useTranslation();
  const location = useLocation();
  const { user, checkedAuth } = useAuth();
  const [isAuthenticating, setIsAuthenticating] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const hasCode = params.has("code");

    if (hasCode && !user && checkedAuth) {
      setIsAuthenticating(true);
    } else if (user || !hasCode) {
      setIsAuthenticating(false);
    }
  }, [location.search, user, checkedAuth]);

  if (isAuthenticating) {
    return (
      <LoadingContainer>
        <img src={loader} alt="Loading" />
        <LoadingText>{t("auth.completingSignIn")}</LoadingText>
      </LoadingContainer>
    );
  }

  return children;
}

export default AuthLoadingWrapper;
